import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatStepper } from '@angular/material/stepper';

import { DeviceDetectorService } from 'ngx-device-detector';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { UserService } from '../../services/user.service';

import { NotePaymentHistoryDetailsListItem, NoteBalanceAdjustmentsListItem, NoteTotalAmountPaidItem } from 'src/app/models/payment';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit {
  private _handleError: HandleError;
  private _logging = environment.logging;
  public show = true;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  userFullName = '';
  participantIdString = '';
  participantId: number = null;
  selectedNoteId: number = null;

  notePaymentHistoryDetailsList: NotePaymentHistoryDetailsListItem[];
  noteBalanceAdjustmentsList: NoteBalanceAdjustmentsListItem[];
  noteTotalAmountPaid: NoteTotalAmountPaidItem[];

  exportDataAvailable = false;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _userService: UserService,
    private _deviceService: DeviceDetectorService,
    public media: MediaObserver
  ) {
    this._handleError = _errorHandler.createHandleError('PaymentHistoryComponent');
    this.userFullName = this._userService.getFullName();
    this.participantId = this._userService.getParticipantId();
    this.participantIdString = this.participantId.toString();
    this.scrollToTop();
  }

  ngOnInit() {}

  toggle() {
    this.show = !this.show;

  }

  scrollToTop() {
    const contentStart = document.getElementsByClassName('mat-sidenav-content');
    if (contentStart.length > 0) {
      contentStart[0].scrollTop = 0;
    }
  }

  onPaymentHistoryListSelected(noteId: number) {
    if (this._userService.isLoggedIn()) {
      this.selectedNoteId = noteId;
      setTimeout(() => {
        const el = document.getElementById('noteDetails');
        el.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  onNotePaymentHistoryDetailsDataReturned(notePaymentHistoryDetailsList: NotePaymentHistoryDetailsListItem[]) {
    this.notePaymentHistoryDetailsList = notePaymentHistoryDetailsList;
    const notePaymentHistoryDetailsListLength =
      this.notePaymentHistoryDetailsList !== undefined && this.notePaymentHistoryDetailsList !== null
        ? this.notePaymentHistoryDetailsList.length
        : 0;
    const noteBalanceAdjustmentsListLength =
      this.noteBalanceAdjustmentsList !== undefined && this.noteBalanceAdjustmentsList !== null
        ? this.noteBalanceAdjustmentsList.length
        : 0;
    const noteTotalAmountPaidLength =
        this.noteTotalAmountPaid !== undefined && this.noteTotalAmountPaid !== null
          ? this.noteTotalAmountPaid.length
          : 0;
    this.exportDataAvailable = notePaymentHistoryDetailsListLength + noteBalanceAdjustmentsListLength + noteTotalAmountPaidLength > 0;
  }

  onNoteBalanceAdjustmentsDataReturned(noteBalanceAdjustmentsList: NoteBalanceAdjustmentsListItem[]) {
    this.noteBalanceAdjustmentsList = noteBalanceAdjustmentsList;
    const notePaymentHistoryDetailsListLength =
      this.notePaymentHistoryDetailsList !== undefined && this.notePaymentHistoryDetailsList !== null
        ? this.notePaymentHistoryDetailsList.length
        : 0;
    const noteBalanceAdjustmentsListLength =
      this.noteBalanceAdjustmentsList !== undefined && this.noteBalanceAdjustmentsList !== null
        ? this.noteBalanceAdjustmentsList.length
        : 0;
    const noteTotalAmountPaidLength =
        this.noteTotalAmountPaid !== undefined && this.noteTotalAmountPaid !== null
          ? this.noteTotalAmountPaid.length
          : 0;
    this.exportDataAvailable = notePaymentHistoryDetailsListLength + noteBalanceAdjustmentsListLength + noteTotalAmountPaidLength > 0;
  }

  onNoteTotalAmountPaidDataReturned(noteTotalAmountPaid: NoteTotalAmountPaidItem[]) {
    this.noteTotalAmountPaid = noteTotalAmountPaid;
    const notePaymentHistoryDetailsListLength =
      this.notePaymentHistoryDetailsList !== undefined && this.notePaymentHistoryDetailsList !== null
        ? this.notePaymentHistoryDetailsList.length
        : 0;
    const noteBalanceAdjustmentsListLength =
      this.noteBalanceAdjustmentsList !== undefined && this.noteBalanceAdjustmentsList !== null
        ? this.noteBalanceAdjustmentsList.length
        : 0;
    const noteTotalAmountPaidLength =
      this.noteTotalAmountPaid !== undefined && this.noteTotalAmountPaid !== null
        ? this.noteTotalAmountPaid.length
        : 0;
    this.exportDataAvailable = notePaymentHistoryDetailsListLength + noteBalanceAdjustmentsListLength + noteTotalAmountPaidLength > 0;
  }

  exportToExcelVisible(): boolean {
    return this._deviceService.isDesktop();
  }
}
